import classnames from 'classnames';
import type {
  FunctionComponent,
  KeyboardEvent,
  MouseEvent,
  PropsWithChildren,
} from 'react';

import { Check } from '@/core/tamagoshi/icons/Check';

import { useSelectContext } from '../../context';

import styles from './Option.module.scss';

export interface OptionProps extends PropsWithChildren {
  value: string;
  index: number;
  className?: string;
  selected?: boolean;
}

export const Option: FunctionComponent<OptionProps> = ({
  className,
  value,
  selected = false,
  index,
  children,
}) => {
  const { onSelectOption, focusedOptionIndex } = useSelectContext();

  const rootClassNames = classnames([
    styles.option,
    { [styles.selected]: selected },
    { [styles.focused]: focusedOptionIndex === index },
    className,
  ]);

  const onHandleClick = (event: MouseEvent) => {
    if (onSelectOption) {
      onSelectOption(event, value);
    }
  };

  const onHandleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && onSelectOption) {
      onSelectOption(event, value);
    }
  };

  return (
    <li
      className={rootClassNames}
      aria-selected={selected}
      tabIndex={-1}
      role="option"
      value={value}
      onClick={onHandleClick}
      onKeyDown={onHandleKeyDown}
    >
      {selected && (
        <Check className={styles.iconCheck} height={20} width={20} />
      )}
      {children}
    </li>
  );
};

Option.displayName = 'Option';
